import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  background-color: ${({ color }) => color || '#002391'};
  height: 120px;
  padding: 0 30px;
  box-sizing: border-box;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-align-content: center;
  -ms-flex-line-pack: center;
  align-content: center;
  color: #fff;
`;

const HeaderContent = styled.p`
  color: #fff;
  font-size: 14px !important;
  float: left;
  -webkit-align-self: center;
  -ms-flex-item-align: center;
  align-self: center;
  font-weight: 500 !important;
`;

/**
 * This component is for setting the header of the CMS pages
 *
 * @author Hessan Aminilou
 * @param {object} children
 * @param {string} color
 */
const CMSHeader = ({ children, color }) => (
  <Container color={color}>
    <HeaderContent>{children}</HeaderContent>
  </Container>
);

export default CMSHeader;
